import { calculateProductPrices } from '../../utils'

const defaultFormatter = (val) => `${val?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
const rialFormatter = (val) => (
    <>
        <span itemProp="price" content={`${val}`}>
            {val?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </span>{' '}
        <span itemProp="priceCurrency" content="IRR">
            ریال
        </span>
    </>
)
const tomanFormatter = (val) => (
    <>
        <span itemProp="price" content={`${val}`}>
            {val?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
        </span>{' '}
        <span itemProp="priceCurrency" content="IRT">
            تومان
        </span>
    </>
)

function Currency({ value, finalValue, product, qty = 1, currency = 'irt', showDiscount = false }) {
    let final_price = finalValue || value,
        price = value

    if (product) {
        let calculations = calculateProductPrices(product)
        final_price = calculations.final_price
        price = calculations.price
    }

    let formatter = defaultFormatter
    switch (currency) {
        case 'irt':
            formatter = tomanFormatter
            break
        case 'irr':
            formatter = rialFormatter
            break
    }
    if (!showDiscount || price === final_price) return formatter(final_price * qty)

    return (
        <>
            <p className="text-red-900 line-through whitespace-no-wrap">
                {defaultFormatter(price * qty)}
            </p>
            <p className="text-green-900 whitespace-no-wrap">{formatter(final_price * qty)}</p>
        </>
    )
}

export { Currency }
